import { fromPromise } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { getAccessToken, loginError } from 'redux/reducers/auth'
import routes from 'routes'
import { Pages } from 'routes/types'
import { consoleLog } from 'utils/Logger'
import { deleteCookie } from 'utils/cokie'

let isRefreshing = false
let pendingRequests = []

const resolvePendingRequests = () => {
  pendingRequests.map((callback) => callback())
  pendingRequests = []
}

const getErrorLink = (dispatch, navigate) => {
  return onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors && Array.isArray([graphQLErrors])) {
      // Check for unauthorized error and redirect to login if unauthorized
      if (graphQLErrors[0]?.extensions?.code === 'UNAUTHORIZED_ERROR') {
        // Few operations like verifyPassword has client side error handling in same page for UnAuth errors.
        // So they are whitelisted from this handling

        let forward$
        if (!isRefreshing) {
          isRefreshing = true
          forward$ = fromPromise(
            getAccessToken(dispatch)
              .then(({ accessToken, refreshToken }) => {
                // Store the new tokens for your auth link

                resolvePendingRequests()
                return accessToken
              })
              .catch((error) => {
                pendingRequests = []
                // Handle token refresh errors e.g clear stored tokens, redirect to login, ...
                consoleLog('inside refresh token error link  catch')
                dispatch(loginError(null))
                setTimeout(() => {
                  navigate(routes[Pages.Login].path)
                }, 1000)
                return forward(operation)
              })
              .finally(() => {
                isRefreshing = false
              }),
          ).filter((value) => Boolean(value))
        } else {
          forward$ = fromPromise(
            new Promise<void>((resolve) => {
              pendingRequests.push(() => resolve())
            }),
          )
        }

        // Check for Internal server error and show the error toast
        // return forward(operation))
        consoleLog('at last of error links')
        return forward$.flatMap(() => forward(operation))
      }
    }
  })
}
export default getErrorLink
